import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#pls4igbm4a)" }, [
      _createElementVNode("path", {
        d: "M8.75 20.083a3.17 3.17 0 0 0 3.167-3.166c0-.572-.155-1.107-.42-1.569l2.684-2.684a3.15 3.15 0 0 0 1.569.42 3.17 3.17 0 0 0 3.167-3.167c0-.235-.033-.457-.083-.668L21.61 7.4a3.14 3.14 0 0 0 2.307 1.018 3.17 3.17 0 0 0 3.166-3.167 3.17 3.17 0 0 0-3.166-3.167A3.17 3.17 0 0 0 20.75 5.25c0 .234.033.456.082.666l-2.777 1.85A3.141 3.141 0 0 0 15.75 6.75a3.17 3.17 0 0 0-3.167 3.167c0 .571.155 1.106.42 1.568L10.32 14.17a3.15 3.15 0 0 0-1.569-.419 3.17 3.17 0 0 0-3.167 3.167 3.17 3.17 0 0 0 3.167 3.166zM23.917 3.75c.826 0 1.5.673 1.5 1.5s-.674 1.5-1.5 1.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5zM15.75 8.417c.827 0 1.5.673 1.5 1.5 0 .826-.673 1.5-1.5 1.5s-1.5-.674-1.5-1.5c0-.827.673-1.5 1.5-1.5zm-7 7c.827 0 1.5.673 1.5 1.5 0 .826-.673 1.5-1.5 1.5s-1.5-.674-1.5-1.5c0-.827.673-1.5 1.5-1.5zm18.667 8.833H3.75V.583a.834.834 0 0 0-1.667 0V24.25h-1.5a.834.834 0 0 0 0 1.667h1.5v1.5a.834.834 0 0 0 1.667 0v-1.5h23.667a.834.834 0 0 0 0-1.667zM23.083 9.917V22.75a.834.834 0 0 0 1.667 0V9.917a.834.834 0 0 0-1.667 0zM7.917 21.583v1.167a.833.833 0 0 0 1.666 0v-1.167a.834.834 0 0 0-1.666 0zm7-7v8.167a.833.833 0 0 0 1.666 0v-8.167a.834.834 0 0 0-1.666 0z",
        fill: "#25262A",
        stroke: "#25262A",
        "stroke-width": ".5"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "pls4igbm4a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h28v28H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }